export default __webpack_public_path__ + "static/media/mochi.61484ebc.jpg";